export function hasStrongTag(html: string): boolean {
  const regex = /<strong(?:\s+[^>]*)?>(.*?)<\/strong>/;
  const matches = html.match(regex);
  return matches !== null;
}

export function removePTag(html: string): string {
  // 's' flag lets '.' match newlines too, so multi-line paragraphs are handled
  const regex = /<p(?:\s+[^>]*)?>([\s\S]*?)<\/p>/gi;
  return html.replace(regex, "$1");
}

export function hasHeadingTag(html: string): boolean {
  const regex = /<h[1-6](?:\s+[^>]*)?>/i;
  return regex.test(html);
}

export function countPTags(html: string): number {
  const regex = /<p(?:\s+[^>]*)?>/gi;
  return html.match(regex)?.length ?? 0;
}
